import { Widget, WIDGET_IFRAME } from "@gaming/srvg-classes-core";


export class IframeWidget extends Widget {
    widgetName: string;
    widget: any;

    constructor( options ) {
        options = options || {};
        options.selector = options.selector || '#iframeWidget';
        super( options );

        this.name = 'widgetiframe';
        this.widgetName = options.widgetName || WIDGET_IFRAME;
        this.widgetName = this.product + this.widgetName;
        this.widget = null;
        this.widgetOptions = {
            height: this.getContainerHeightWithUnit()
        };
        this.mergeWidgetOptions(options);
    }

    handleDomInstantiated() {
        this.addIframeWidget();
        super.handleDomInstantiated();
    }

    /**
     * add text widget to given selector (html element selector)
     * @param string selector html element selected (not element itself)
     */
    addIframeWidget(selector?) {
        var that = this;
        selector = selector || this.selector;
        this.widget = this.addWidget(
            selector,
            this.widgetName,
            this.widgetOptions
        );
    }

}